export default {
  numericToDate(num) {
    return new Date(this.numericToISO(num))
  },

  numericToISO(num = 0) {
    const n = String(num).trim();

    if (!n.length) {
      return '0000-00-00'
    }
    return `${n[0]}${n[1]}${n[2]}${n[3]}-${n[4]}${n[5]}-${n[6]}${n[7]}`;
  },

  isoToNumeric(str) {
    return str ? Number(str.replace(/-/g, '')) : null
  },

  dateToNumeric(date) {
    return this.isoToNumeric(date.toISOString().split('T')[0]);
  },

  // "2020-09-27-16.46.56.092721"
  customTextToDate(str) {
    const [y, m, d, h, i, s, ms] = str.replace(/\./g, '-').split('-');
    return new Date(y, m, d, h, i, s, ms);
  },

}